import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetGvcQuery } from "../../store/api/gvcApi";
import { GvcDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "gvc";
export const GvcDetailInitializer: React.FC = () => {
  const { org: orgName, gvc: gvcName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/gvc/${gvcName}`;

  const { data: gvc, isLoading, isFetching, isError, error, refetch } = useGetGvcQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!gvc && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="gvc" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !gvc) {
    return <IncorrectItem kind="gvc" canCreate={true} />;
  }

  return <GvcDetailForm key={gvcName} gvc={gvc} />;
};
